export enum AccessoryType {
    Accessory = 'Accessory',
    Optional= 'Optional'
}
